module.exports = __webpack_public_path__ + "static/media/logo.32f9d1e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 64
// module chunks = 0